export class ProductModel {
  constructor({ id, name, code, quantity, type, unity, family, children, familia_produto, tipo, label, updated_at }) {
    this.id = id;
    this.name = name;
    this.code = code;
    this.quantity = quantity;
    this.type = type;
    this.unity = unity;
    this.family = family;
    this.children = children;
    this.familia_produto = familia_produto;
    this.tipo = tipo;
    this.label = label;
    this.updated_at = updated_at;
  }

  static fromJson(json) {
    const nameD = json.desc ?? json.produto_desc;
    const codeD = json.cod ?? json.produto_codigo;
    const labelD = `${codeD - nameD}`;

    return new ProductModel({
      id: json.produto_cod,
      name: nameD,
      code: codeD,
      label: labelD,
      quantity: Number(json.qt ?? 0),
      unity: json.unidade ?? json.und,
      family: json.produto_familia?.familia_nome ?? "Sem fml",
      updated_at: json.updated_at ?? null,
      type: ProductType.fromJson(extractType(json)),
      familia_produto: json.familia_produto
        ? {
            id: json.familia_produto.id,
            familia_nome: json.familia_produto.familia_nome,
          }
        : null,
      tipo: json.tipo
        ? {
            id: json.tipo.id,
            nome: json.tipo.nome,
          }
        : null,
      children: json.filhos?.map((e) => this.fromJson(e)) ?? [],
    });
  }
}

function extractType(json) {
  if (!json.tipo) {
    return {
      id: 0,
      nome: json.produto_tipo ?? "Sem tipo",
    };
  } else {
    return json.tipo;
  }
}

class ProductType {
  constructor({ id, name }) {
    this.id = id;
    this.name = name;
  }

  static fromJson(json) {
    return new ProductType({
      id: json.id,
      name: json.nome,
    });
  }
}
